import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import SettingsPanel from "./shared/SettingsPanel";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";
import { AuthProvider } from "./Context/AuthContext";

const App = ({ i18n }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  useEffect(() => {
    onRouteChanged();
  }, [location]);

  const onRouteChanged = () => {
    const body = document.querySelector("body");

    if (location.pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
      i18n.changeLanguage("ar");
    } else {
      body.classList.remove("rtl");
      i18n.changeLanguage("en");
    }

    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      "/login-1",
      "/user-pages/register-1",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
    ];

    if (fullPageLayoutRoutes.includes(location.pathname)) {
      setIsFullPageLayout(true);
      document
        .querySelector(".page-body-wrapper")
        .classList.add("full-page-wrapper");
    } else {
      setIsFullPageLayout(false);
      document
        .querySelector(".page-body-wrapper")
        .classList.remove("full-page-wrapper");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authData"); 
    if (!token && location.pathname !== "/login-1") {
      navigate("/login-1");
    }
  }, [location.pathname, navigate]);

  return (
    <div className="container-scroller">
      {!isFullPageLayout && <Navbar />}
      <div className="container-fluid page-body-wrapper">
        {!isFullPageLayout && <Sidebar />}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
            {!isFullPageLayout && <SettingsPanel />}
          </div>
          {!isFullPageLayout && <Footer />}
        </div>
      </div>
    </div>
  );
};

const AppWithRouter = (props) => (
  <AuthProvider>
    <App {...props} />
  </AuthProvider>
);

export default withTranslation()(AppWithRouter);
